import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconArrowUp$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconArrowUp extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'b1e75c3a3f4a2d03173f5badbcdb1ba0aacc10bd', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '78f16bcbb2e6da98a938d67d44eba5af49098096', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '6fa132234811b78d48392f6aba73e36bcaf7a160', d: "m11.746 6.72 3.146 3.145a.5.5 0 0 0 .707 0l.353-.353a.5.5 0 0 0 0-.707l-4.596-4.597a.5.5 0 0 0-.357-.146.5.5 0 0 0-.356.146L6.046 8.805a.5.5 0 0 0 0 .707l.354.353a.5.5 0 0 0 .707 0l3.14-3.139v10.718a.5.5 0 0 0 .5.5h.5a.5.5 0 0 0 .5-.5z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-arrow-up", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-arrow-up"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-arrow-up":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconArrowUp$1);
            }
            break;
    } });
}

const CosmosIconArrowUp = CosmosIconArrowUp$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconArrowUp, defineCustomElement };
